export const rcpErrorStatuses = [
  'plan_error',
  'provision_error',
  'update_error',
  'validate_provision_error',
  'destroy_error'
] as RcpStatus[];
